import { useSeoMeta } from '@unhead/react';
import { About } from '@/components/portfolio/About';
import { Beyond } from '@/components/portfolio/Beyond';
import { Footer } from '@/components/portfolio/Footer';
import { Hero } from '@/components/portfolio/Hero';
import { Journey } from '@/components/portfolio/Journey';
import { Marquee } from '@/components/portfolio/Marquee';
import { Nav } from '@/components/portfolio/Nav';
import { Projects } from '@/components/portfolio/Projects';
import { Stack } from '@/components/portfolio/Stack';
import { marqueeWords } from '@/lib/portfolio';

const outroWords = [
  "Let's build",
  'Nairobi to the world',
  'Ship it',
  'Proof of taste',
  'Hakuna matata',
  'On-chain & off',
  'To the moon, via Ngong Rd',
];

const Index = () => {
  useSeoMeta({
    title: 'Immaculate Munde — CTO, AI & Web3 Builder | The Munde-Verse',
    description:
      'The digital universe of Immaculate Munde: 20-year-old Co-founder & CTO of MissFit Tech, AI engineer and Web3 builder from Nairobi, shipping across Bitcoin, Lightning, Stellar, Avalanche and beyond.',
    ogTitle: 'Immaculate Munde — CTO, AI & Web3 Builder',
    ogDescription:
      'Twenty, Nairobi-based, and allergic to boring software. Explore the projects, chains and chaos of the Munde-Verse.',
    ogType: 'website',
    ogUrl: 'https://mundes-world.shakespeare.wtf/',
    ogImage: 'https://mundes-world.shakespeare.wtf/og-image.jpg',
    twitterCard: 'summary_large_image',
    twitterSite: '@Imm9cul9t3',
    twitterCreator: '@Imm9cul9t3',
    twitterImage: 'https://mundes-world.shakespeare.wtf/og-image.jpg',
  });

  return (
    <div className="relative min-h-screen overflow-x-clip bg-background text-foreground">
      {/* Film grain */}
      <div className="grain pointer-events-none fixed inset-0 z-[60] opacity-[0.05] mix-blend-overlay" aria-hidden="true" />

      <Nav />

      <main>
        <Hero />

        <div className="relative z-10 -my-3 -rotate-2 scale-[1.03] bg-nova py-1 text-primary-foreground shadow-[0_10px_60px_-15px_hsl(14_95%_60%/0.6)]">
          <Marquee items={marqueeWords} />
        </div>

        <About />
        <Stack />
        <Projects />
        <Journey />
        <Beyond />

        <div className="relative z-10 -my-3 rotate-1 scale-[1.03] bg-pulsar py-1 text-primary-foreground shadow-[0_10px_60px_-15px_hsl(265_90%_68%/0.6)]">
          <Marquee items={outroWords} fast />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Index;
